const DEFAULT_LOCALE = 'en-GB';

const formatDateLocaleDependent = (isoDate: string): string => {
  const date = new Date(isoDate);
  const locale = navigator.language || DEFAULT_LOCALE;

  // Use Intl.DateTimeFormat to get locale-appropriate format
  const formatter = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  const day = parts.find((part) => part.type === 'day')?.value || '';
  const month = parts.find((part) => part.type === 'month')?.value || '';

  // For US locales, format as MM/DD, for others as DD/MM
  if (locale.startsWith('en-US')) {
    return `${month}/${day}`;
  } else {
    return `${day}/${month}`;
  }
};

export default formatDateLocaleDependent;
